module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-520.e2aac92.woff2";